<template>
  <div class="campaign-card-body">
    <div class="campaign-card-body__title">{{ titleEllipsis }}</div>
    <div class="campaign-card-body__associate">
      {{ associateFullNameEllipsis }}
    </div>
    <div class="campaign-card-body__amount">
      <CampaignCardBodyProgress
        :current-value="currentValue"
        :goal="goal"
        :extra-goal1="extraGoal1"
        :extra-goal2="extraGoal2"
      />
      <CampaignCardBodyAmount
        class="campaign-card-body__amount__summary"
        :is-target-donor="isTargetDonor"
        :current-value="currentValue"
        :goal="goal"
      />
    </div>
  </div>
</template>

<script>
import CampaignCardBodyAmount from '@/components/CampaignCardBodyAmount';
import CampaignCardBodyProgress from '@/components/CampaignCardBodyProgress';
import { ellipsis } from '@/format-helper';

export default {
  name: 'CampaignCardBody',
  components: {
    CampaignCardBodyAmount,
    CampaignCardBodyProgress,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    associate: {
      type: Object,
      required: true,
    },
    isTargetDonor: {
      ...CampaignCardBodyAmount.props.isTargetDonor,
    },
    currentValue: {
      ...CampaignCardBodyAmount.props.currentValue,
    },
    goal: {
      ...CampaignCardBodyProgress.props.goal,
    },
    extraGoal1: {
      ...CampaignCardBodyProgress.props.extraGoal1,
    },
    extraGoal2: {
      ...CampaignCardBodyProgress.props.extraGoal2,
    },
  },
  computed: {
    titleEllipsis() {
      return ellipsis(this.title, 50);
    },
    associateFullNameEllipsis() {
      return ellipsis(this.associate.name, 25);
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 12px 16px 24px;
}

.campaign-card-body__title {
  flex: 1 1 auto;
  position: relative;

  font-size: 16px;
  font-weight: bold;
  line-height: 22.5px;
}

.campaign-card-body__associate {
  margin-top: 8px;

  font-size: 12px;
  line-height: 18px;
}

.campaign-card-body__amount {
  margin-top: 12px;
}

.campaign-card-body__amount__summary {
  margin-top: 12px;
}
</style>
